import * as React from 'react'
import { forwardRef } from 'react'
import { TDrawingTool } from '../types'
import { createCursorStyle } from './cursorHelpers'

/**
 * Canvas component for drawing the mask.
 * Both brush and erase tools add white pixels to create the mask.
 */
interface MaskCanvasProps {
	tool: TDrawingTool
	isActive: boolean
	brushSize: number
	onMouseDown: (e: React.MouseEvent) => void
	onMouseMove: (e: React.MouseEvent) => void
	onMouseUp: () => void
	onMouseLeave: () => void
}

export const MaskCanvas = forwardRef<HTMLCanvasElement, MaskCanvasProps>(
	({ tool, isActive, brushSize, onMouseDown, onMouseMove, onMouseUp, onMouseLeave }, ref) => {
		const cursorStyle = createCursorStyle(tool, isActive, brushSize)

		return (
			<canvas
				ref={ref}
				style={{
					position: 'absolute',
					maxWidth: '100%',
					maxHeight: '100%',
					width: 'auto',
					height: 'auto',
					cursor: cursorStyle,
					pointerEvents: isActive ? 'auto' : 'none',
					zIndex: 2,
				}}
				onMouseDown={onMouseDown}
				onMouseMove={onMouseMove}
				onMouseUp={onMouseUp}
				onMouseLeave={onMouseLeave}
			/>
		)
	},
)

MaskCanvas.displayName = 'MaskCanvas'
